import React from "react";
import {
	GuildData,
	EventCreationProps,
	PollCreationProps,
	IWebConfirmationData,
} from "../../../common/sesh_types";
import FadeIn from "../../../src/vendored/FadeIn";
import { DashboardUtils, FADE_IN_ANIMATION_DURATION } from "./dashboard_utils";
import { SeshPrimaryButton } from "./forms/improved_components/base_components/sesh_primary_button";
import { useHistory } from "react-router";
import { common_utils } from "../../../common/common_utils";
import { useServerId } from "./forms/improved_components/hooks/use_server_id";

export function EventCreationConfirmation(props: {
	is_edit: boolean;
	link?: string;
	onClose: () => void;
}) {
	const history = useHistory();
	const server_id = useServerId();

	return (
		<DashboardUtils.SeshModal
			is_active={true}
			onClose={props.onClose}
			title={
				<div className="flex items-center justify-center gap-2">
					<span>
						Event successfully{" "}
						{props.is_edit ? "edited" : "created"}!
					</span>
					{props.link && (
						<a
							href={props.link.replace("https", "discord")}
							className="manual-link"
							style={{
								background: "none",
								border: "none",
								padding: 0,
							}}
							title="View Event in Discord"
						>
							<i className="fas fa-external-link-alt"></i>
						</a>
					)}
				</div>
			}
			content={
				<div className="columns is-mobile is-multiline is-centered pt-4">
					<div className="column is-narrow">
						<DashboardUtils.CreateOptionsButton
							on_click={() =>
								history.push(
									common_utils.getEventCreateURL(server_id)
								)
							}
							button_name="Create New Event"
							icon={DashboardUtils.GetEventIcon()}
						/>
					</div>
				</div>
			}
		/>
	);
}

export function PollCreationConfirmation(props: {
	poll_props: PollCreationProps;
	guild_data: GuildData;
	reset_state_func: () => void;
}) {
	const containerClassName =
		"column is-11-mobile is-three-quarters-tablet is-three-quarters-desktop is-half-widescreen is-two-fifths-fullhd create-event-container is-centered";
	return (
		<FadeIn transitionDuration={FADE_IN_ANIMATION_DURATION}>
			<div
				className="columns is-centered is-mobile"
				style={{ transition: "opacity 0.5s", opacity: "1" }}
			>
				<div className={containerClassName}>
					<DashboardUtils.RenderLinkChain
						link_chain_data={[
							DashboardUtils.GetGuildSelectionLinkChainData(),
							DashboardUtils.RenderGuildOptionSelectLinkChain(
								props.guild_data
							),
							DashboardUtils.RenderPollSelectionLinkChain(
								props.guild_data
							),
							DashboardUtils.RenderPollCreateLinkChain(
								props.poll_props.guild_id,
								props.poll_props.is_edit
							),
						]}
					/>
					<h1 className="title is-3 has-text-centered !mb-8">
						Poll successfully{" "}
						{props.poll_props.is_edit ? "edited" : "created"}!
					</h1>
					<div className="columns is-mobile is-multiline is-centered">
						<div className="column is-narrow">
							<DashboardUtils.CreateOptionsButton
								button_name="Create New Poll"
								icon={DashboardUtils.GetPollIcon()}
								on_click={props.reset_state_func}
							/>
						</div>
					</div>
				</div>
			</div>
		</FadeIn>
	);
}
